"use client";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { HOME_PAGE } from "src/settings/constant";
import { useDialogStore } from "src/store/useDialogStore";
const INACTIVE_EDITION_DIALOG_ID = "inactive-edition-dialog";
/**
 * 종료된 기획전 다이얼로그 훅
 * - isActive가 false일 때 다이얼로그 표시
 * - "홈으로 돌아가기" 버튼 클릭 시 홈 페이지로 이동
 */ export const useInactiveEditionDialog = ()=>{
    const router = useRouter();
    const { open , close  } = useDialogStore();
    const openInactiveDialog = ()=>{
        open({
            id: INACTIVE_EDITION_DIALOG_ID,
            type: "confirm",
            props: {
                title: "종료된 기획전이에요.",
                confirmText: "홈으로 돌아가기",
                onConfirm: ()=>{
                    router.push(HOME_PAGE);
                },
                // 배경 클릭이나 ESC로 닫히지 않도록 설정
                onCancel: ()=>{
                    router.push(HOME_PAGE);
                },
                classes: {
                    dialogTitle: {
                        titleContainer: "md:items-start"
                    }
                }
            }
        });
    };
    const closeDialog = ()=>{
        close(INACTIVE_EDITION_DIALOG_ID);
    };
    return {
        openInactiveDialog,
        closeDialog
    };
};
/**
 * isActive 상태에 따라 자동으로 다이얼로그를 표시하는 훅
 * @param isActive - 기획전 활성 상태
 * @param isLoading - 로딩 상태
 */ export const useInactiveEditionCheck = (isActive, isLoading)=>{
    const { openInactiveDialog  } = useInactiveEditionDialog();
    useEffect(()=>{
        // 로딩 중이거나 isActive가 undefined이면 아무것도 하지 않음
        if (isLoading || isActive === undefined) return;
        // isActive가 false이면 다이얼로그 표시
        if (isActive === false) {
            openInactiveDialog();
        }
    }, [
        isActive,
        isLoading
    ]);
};
